<template>
  <div id="telLogin">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleFormTel"
      label-width="0"
      class="form_box"
      style="margin-right:50px;"
    >
      <el-form-item prop="telNumber">
        <el-input
          size="small"
          v-model="ruleForm.telNumber"
          placeholder="请输入手机号"
          maxlength="11"
          :clearable="true"
          autocomplete="off"
          v-on:keyup.enter.native="submitForm('ruleFormTel')"
        ></el-input>
      </el-form-item>
      <el-form-item prop="verCode" style="margin-bottom:0">
        <el-input
          size="small"
          v-model="ruleForm.verCode"
          style="width:180px"
          placeholder="验证码"
          maxlength="6"
          autocomplete="off"
          v-on:keyup.enter.native="submitForm('ruleFormTel')"
        ></el-input>
        <el-button
          size="small"
          class="fr vm"
          style="margin-top:5px"
          :disabled="isGetCode"
          @click="getVercode()"
        >{{codeValue}}</el-button>
      </el-form-item>
      <!-- <div class="mt-10 sigh" style="margin-left:50px;height:16px;"> -->
      <div class="mt-10 sigh" style="height:10px;">
        <p style="color:#ec4452;margin-left:10px" v-if="errorText != ''">{{errorText}}</p>
      </div>
      <el-form-item class="mt-20">
        <el-button
          type="primary"
          class="button"
          size="small"
          style="width:100%;"
          @click="submitForm('ruleFormTel')"
        >绑定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setCookie } from '@/uitls/index.js'

export default {
  data() {
    // 手机号码验证规则
    const telNumber = (rule, value, callback) => {
      let reg = /^1\d{10}$/
      if (!reg.test(value)) {
        callback(new Error('请正确输入手机号码'))
      } else {
        callback()
      }
    }
    return {
      // 错误提示
      errorText: '',
      codeValue: '获取验证码',
      ruleForm: {
        telNumber: '',
        verCode: ''
      },
      isVerifyCode: false,
      rules: {
        telNumber: [{ validator: telNumber, trigger: 'blur' }],
        verCode: [
          { required: true, message: '请输验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '验证码长度为6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 提交表单
    submitForm() {
      this.$refs.ruleFormTel.validate(valid => {
        if (valid) {
          this.$http
            .post('/user-server/user/bindPhoneNo', {
              userId: sessionStorage.getItem('userId'),
              phoneNo: this.ruleForm.telNumber,
              verificationCode: this.ruleForm.verCode
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message)
                sessionStorage.removeItem('userId')
                this.$emit('success')
                setCookie('accesstoken', res.data.value, 1)
                // this.$router.push('/tipsbind')
              } else {
                this.$message.error(res.data.message)
              }
              console.log(res)
            })
            .catch(err => {
              console.log(err)
            })
        }
      })
    },
    // 手机登录获取验证码
    getVercode() {
      this.verifyCode()
      this.$http
        .post('/user-server/user/sendShortMessage', {
          phoneNo: this.ruleForm.telNumber,
          motion: 'bindPhone'
        })
        .then(res => {
          if (res.data.code == 200) {
            console.log('sucess')
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取验证码
    /**
     * targetTime 预期时间戳
     */
    verifyCode(targetTime) {
      this.isVerifyCode = true
      let targetNumber = targetTime
        ? targetTime
        : Number.parseInt((new Date().getTime() + 60000) / 1000)
      let curNumber = Number.parseInt(new Date().getTime() / 1000)
      let countNuber = targetNumber - curNumber
      if (countNuber <= 0) {
        sessionStorage.removeItem('cloud-bind')
        this.codeValue = '获取验证码'
        this.isVerifyCode = false
        return
      }
      this.codeValue = countNuber + '秒后重新获取'
      sessionStorage.setItem('cloud-bind', targetNumber)
      let timer = null
      timer = setInterval(() => {
        curNumber = Number.parseInt(new Date().getTime() / 1000)
        countNuber = targetNumber - curNumber
        this.codeValue = targetNumber - curNumber + '秒后重新获取'
        if (countNuber < 0) {
          sessionStorage.removeItem('cloud-bind')
          clearInterval(timer)
          this.codeValue = '获取验证码'
          this.isVerifyCode = false
        }
      }, 1000)
    },
    mounted() {
      if (sessionStorage.getItem('cloud-bind')) {
        let timeCode = sessionStorage.getItem('cloud-bind')
        this.verifyCode(Number.parseInt(timeCode))
      }
    }
  },
  computed: {
    // 获取验证码按钮是否可点击
    isGetCode() {
      let reg = /^1\d{10}$/
      if (reg.test(this.ruleForm.telNumber) && !this.isVerifyCode) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    // 监听登录的手机号码只能输入数字
    'ruleForm.telNumber'() {
      let reg = /^[0-9]*$/
      let str = this.ruleForm.telNumber
      if (!reg.test(str)) {
        console.log(
          this.ruleForm.telNumber.substring(
            0,
            this.ruleForm.telNumber.length - 1
          )
        )
        this.ruleForm.telNumber = this.ruleForm.telNumber.substring(
          0,
          this.ruleForm.telNumber.length - 1
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#telLogin {
  margin: 0 auto;
  width: 100%;
  background-color: #ffffff;
  border-radius: 6px;
  .button {
    color: #fff;
    width: 100%;
    background-color: #ec4452;
    background: #ec4452;
    border-color: #ec4452;
    border-radius: 4px;
    &:hover {
      background-color: #f17d86;
      border-color: #f17d86;
    }
    &:active {
      background-color: #db2637;
      border-color: #db2637;
    }
  }
  .form_box {
    margin: 0 50px;
    .sigh {
      & > p {
        position: relative;
        padding-left: 20px;
        &::after {
          content: '!';
          position: absolute;
          left: 0;
          top: 2px;
          width: 16px;
          height: 16px;
          background-color: #ec4452;
          border-radius: 50%;
          text-align: center;
          line-height: 16px;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cloudStructure/components/bind.vue